import { Collapsible } from './shared/webcomponents/collapsible';

if (!customElements.get('collapsible-element')) {
  customElements.define('collapsible-element', Collapsible);
}
